import React, { Component } from 'react';
import AMS from '@ui/components/ams';
import styled from 'styled-components';
import NinjaLayoutDiv from '../../../templates/NinjaLayout';
import MobileMenu from './MobileMenu';
import theme from '../../../theme';
import { MaxWidthLayoutDesktop } from '../../../templates/MaxWidthLayout';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import {
  getCurrentRelativeUrl,
  URL_STATE_CHANGE_EVENT,
} from '../../../../lib/utils';

const SkipNavigationDiv = styled.div`
  background-color: ${(p) => p.theme.c.bg.info};
  height: 48px;
  position: fixed;
  width: 100%;
  top: -200px;
  display: flex;
  align-items: center;
  :focus-within {
    position: static;
  }
`;

const SkipNavigationLink = styled.a`
  ${(p) => p.theme.typographyRebrand.body.lg}
  color: ${(p) => p.theme.c.text.interactive};
`;

class MenuWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      currentPath: '',
      notificationIsVisible: true,
    };
    this.skipElement;
    this.mobileMenuHandler = this.mobileMenuHandler.bind(this);
    this.setSkipElement = this.setSkipElement.bind(this);
    this.syncCurrentPath = this.syncCurrentPath.bind(this);
  }

  componentDidMount() {

    this.syncCurrentPath();

    // If mobile menu is open and user resizes to desktop, close menu
    window.addEventListener('resize', this.onResizeEvent);
    window.addEventListener(URL_STATE_CHANGE_EVENT, this.syncCurrentPath);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeEvent);
    window.removeEventListener(URL_STATE_CHANGE_EVENT, this.syncCurrentPath);
  }

  syncCurrentPath() {
    this.setState({ currentPath: getCurrentRelativeUrl() });
  }

  onResizeEvent = () => {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (this.state.isMobileMenuOpen && width >= theme.breakpoints.m[0]) {
      this.setState({ isMobileMenuOpen: false });
    }
  };

  mobileMenuHandler = () => {
    this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen });
  };

  listenToScroll = () => {
    this.skipElement && this.skipElement.blur && this.skipElement.blur();
  };

  setSkipElement = (element) => {
    this.skipElement = element;
    this.skipElement.addEventListener('focus', () => {
      document.body.addEventListener('scroll', this.listenToScroll);
    });
    this.skipElement.addEventListener('blur', () => {
      document.body.removeEventListener('scroll', this.listenToScroll);
    });
  };

  render() {
    const {
      children,
      searchNavBarData,
      catNavBarData,
      globalNavData,
      locale,
      pageName,
      isUserLoggedIn,
      userShopsData,
      pageStateModifiers,
      localeUrls,
      subCategoryLocaleSlugMap,
      globalPageConfig,
      notificationData,
      userData = {},
    } = this.props;

    const {
      visitInfo = {}
    } = userData;

    const DesktopBody = () => {
      return (
        <div>
          <header>
            <SkipNavigationDiv>
              <MaxWidthLayoutDesktop>
                <SkipNavigationLink
                  href="#main-content"
                  innerRef={(element) => element && this.setSkipElement(element)}
                >
                  {globalPageConfig.skipNavigationLabel || 'Skip Navigation'}
                </SkipNavigationLink>
              </MaxWidthLayoutDesktop>
            </SkipNavigationDiv>
            <AMS.NotificationSlot {...notificationData} locale={locale} closeIconLabel={globalPageConfig.closeIconLabel} />
            <AMS.GlobalNavigation
              {...globalNavData}
              locale={locale}
              pageName={pageName}
              pageStateModifiers={pageStateModifiers}
              currentPath={this.state.currentPath}
              localeUrls={localeUrls}
              subCategoryLocaleSlugMap={subCategoryLocaleSlugMap}
              globalPageConfig={globalPageConfig}
              visitInfo={visitInfo}
            />
            <AMS.NavigationSearchBar
              {...searchNavBarData}
              locale={locale}
              pageName={pageName}
              isUserLoggedIn={isUserLoggedIn}
              isMobileMenuOpen={this.state.isMobileMenuOpen}
              mobileMenuHandler={this.mobileMenuHandler}
              pageStateModifiers={pageStateModifiers}
              currentPath={this.state.currentPath}
              localeUrls={localeUrls}
             />
          </header>
          <nav>
            <AMS.NavigationCategoriesBar
              userData={userData}
              locale={locale}
              userShopsData={userShopsData}
              pageStateModifiers={pageStateModifiers}
              globalPageConfig={globalPageConfig}
              {...catNavBarData} />
          </nav>
          {children}
        </div>
      );
    };

    const MobileBody = () => {
      return (
        <div>
          <header>
            {this.state.notificationIsVisible
            && (
            <SkipNavigationDiv>
              <MaxWidthLayoutDesktop>
                <SkipNavigationLink href="#main-content">{globalPageConfig.skipNavigationLabel || 'Skip Navigation'}</SkipNavigationLink>
              </MaxWidthLayoutDesktop>
            </SkipNavigationDiv>
            )}
            <AMS.NavigationSearchBar
              {...searchNavBarData}
              locale={locale}
              pageName={pageName}
              isUserLoggedIn={isUserLoggedIn}
              isMobileMenuOpen={this.state.isMobileMenuOpen}
              mobileMenuHandler={this.mobileMenuHandler}
              pageStateModifiers={pageStateModifiers}
              currentPath={this.state.currentPath}
              localeUrls={localeUrls}
              />
          </header>
          <nav>
            <NinjaLayoutDiv hidden={!this.state.isMobileMenuOpen}>
              <MobileMenu
                visitInfo={visitInfo}
                locale={locale}
                theme={theme}
                isUserLoggedIn={isUserLoggedIn}
                searchNavBarData={searchNavBarData}
                catNavBarData={catNavBarData}
                globalNavData={globalNavData}
                pageStateModifiers={pageStateModifiers}
                currentPath={this.state.currentPath}
                localeUrls={localeUrls}
                subCategoryLocaleSlugMap={subCategoryLocaleSlugMap}
                globalPageConfig={globalPageConfig}
                closed={!this.state.isMobileMenuOpen} />
            </NinjaLayoutDiv>
          </nav>
          <AMS.NotificationSlot {...notificationData} locale={locale} closeIconLabel={globalPageConfig.closeIconLabel} />
          <NinjaLayoutDiv hidden={this.state.isMobileMenuOpen}>
            { children }
          </NinjaLayoutDiv>
        </div>
      );
    };

    const renderComp = (
      <MediaQueryHelper
        desktopChildren={DesktopBody()}
        mobileChildren={MobileBody()} />
    );

    return renderComp;

  }
}

export default MenuWrapper;
